<template>
    <div class="col-12 col-lg-5 ml-auto" v-if="defaultSpinner == 'spinbot' || defaultSpinner == 'spinrewriter'">
        <label for="tags-input">
            {{ localizationStore.translate(defaultSpinner == 'spinbot' ? "spin.letter.tag.input.label" : 'spinrewriter.letter.tag.input.label') }}
        </label>
        <vue-tags-input
            v-model="tag"
            :tags="tags"
            @tags-changed="newTags => tags = newTags"
            :placeholder="localizationStore.translate(defaultSpinner == 'spinbot' ? 'spin.letter.tag.input.placeholder' : 'spinrewriter.letter.tag.input.placeholder')"
        />
    </div>
    <payment-modal
        :id="'top-up-modal'"
        :top-up-type="topUpType"
    >
        <template #header>
            <div class="d-flex">
                <img :src="settingStore.modalLogo" class="mb-2 w-50 mx-auto" alt="creditfixrr">
            </div>
            <h3 class="text-primary text-center mb-1">
                {{ localizationStore.translate("top.up.modal.title") }}
            </h3>
            <div v-if="error" class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                <div class="alert-body d-flex align-items-center">
                    <vue-feather type="info" size="14" class="mr-50 align-middle top-0" />
                    <span v-html="message"></span>
                </div>
            </div>
            <template v-for="(topUp, name) in planStore.topUps">
                <input
                    type="radio"
                    name="top-up-type"
                    v-model="topUpType"
                    :value="name"
                    :id="`top-up-${name}`"
                    class="custom-control-input"
                />
                <label :for="`top-up-${name}`" class="card radio-box mb-50">
                    <div class="card-body p-75">
                        <div class="d-flex justify-content-between flex-wrap">
                            <h6 class="font-weight-bolder mb-0">
                                {{ localizationStore.translate(`top.up.modal.package.${name}.title`) }}
                            </h6>
                            <h6 class="font-weight-bolder mb-0">
                                {{ localizationStore.translate(`top.up.modal.package.${name}.price`, { price: `$${topUp.price}` }) }}
                            </h6>
                        </div>
                        <p
                            class="card-text"
                            v-html="localizationStore.translate(`top.up.modal.package.${name}.description`, { price: `$${topUp.price}`, credit: topUp.credit })"
                            
                        ></p>
                    </div>
                </label>
            </template>
        </template>
        <template #footer="{ topUp }">
            <div class="row gy-1 gx-2 mt-75">
                <div class="col-12 text-center">
                    <button type="button" @click.once="topUp" class="btn btn-primary mr-1 mt-1" :key="planStore.paymentBtnKey">
                        {{ localizationStore.translate("top.up.modal.button.save") }}
                    </button>
                    <button @click="hideModal('#top-up-modal')" type="reset" class="btn btn-outline-secondary mt-1" aria-label="Close">
                        {{ localizationStore.translate("top.up.modal.button.cancel") }}
                    </button>
                </div>
            </div>
        </template>
    </payment-modal>
</template>
<style>
.vue-tags-input {
    display: block;
    width: 100%;
    height: auto;
    padding: 5px;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.45;
    color: #6e6b7b;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #d8d6de;
    border-radius: 0.357rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    max-width: none !important;
}
.vue-tags-input .ti-input {
    padding: 0px;
    border: none;
}
</style>
<script>
    import { useChatStore } from '../stores/ChatStore.js'
    import { useLocalizationStore } from '../stores/LocalizationStore.js'
    import { useUserStore } from '../stores/UserStore.js'
    import { usePlanStore } from '../stores/PlanStore.js'
    import { useSettingStore } from '../stores/SettingStore.js'
    import { reactive, ref } from 'vue'
    import VueTagsInput from '@sipec/vue3-tags-input'
    import noUiSlider from 'nouislider'
    import 'nouislider/dist/nouislider.css';
    import "../../css/base/plugins/extensions/ext-component-sliders.css";
    import { useSpinStore } from '../stores/SpinStore.js'
    import PaymentModal from './modals/PaymentComponent'
    import { closeModal, hideModal, openModal } from '../utilities/_helpers'
    import Swal from 'sweetalert2'
    export default {
        mounted() {
            // noUiSlider.create(this.$refs.sliderChangsPerSentence, this.spinStore.sliderOptions);
        },
        props: {
            editorRef: {
                type: Object
            }
        },
        components: {
            VueTagsInput,
            PaymentModal
        },
        setup(props) {
            const spinStore = useSpinStore();
            return {
                chatStore: useChatStore(),
                localizationStore: useLocalizationStore(),
                userStore: useUserStore(),
                planStore: usePlanStore(),
                settingStore: useSettingStore(),
                charaterCount: ref(0),
                isSpining: ref(false),
                tag: ref(''),
                tags: reactive([]),
                spinStore: spinStore,
                defaultSpinner: ref(spinStore.defaultSpinner),
                topUpType: ref(null),
                closeModal: closeModal,
                hideModal: hideModal
            };
        },
        watch: {
        },
        mounted() {
            this.chatStore.activeChat.length = 0;
            this.chatStore.conversations.data.length = 0;
            if(_.isEmpty(this.userStore.user)){
                this.userStore.fetchUser();
            }
        },
        methods: {
            callSpin: function($this, elements, range, length) { // async =>
                const letterSpinUrl = this.$router.resolve({
                    name: 'spin-letter',
                }).href;
                axios.post(letterSpinUrl, { // await
                    content: elements[length].innerHTML,
                    range: range == 0 ? 1 : range
                })
                .then(function (response) {
                    if (response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                    }
                    elements[length].innerHTML = response.data.data.content;
                    elements[length].classList.add("letter-content-background");
                    length--;
                    if (length >= 0) {
                        $this.callSpin($this, elements, range, length);
                    }
                    else {
                        $this.userStore.user.balance = response.data.data.balance;
                        $this.isSpining = false;
                        Swal.close();
                    }
                })
                .catch(function (error) {
                    length--;
                    if (length >= 0) {
                        $this.callSpin($this, elements, range, length);
                    }
                    else {
                        $this.isSpining = false;
                        Swal.close();
                    }
                    toastr.error(error.message, 'Error!');
                });
            },
            spinLetter: function () {
                var $this = this, payload = {};
                const letterSpinUrl = this.$router.resolve({
                    name: 'spin-letter',
                }).href;
                this.counter();
                if (this.charaterCount > this.spinStore.maxCharaterAllowed) {
                    toastr.error(`Cannot Spin more than ${this.spinStore.maxCharaterAllowed}`, 'Error!');
                    return;
                }
                let separatorList = ['separator', 'null'],
                    selectedSeparator = '||||',
                    contentData = '';
                var content = '',
                    contentsEditorLeft = tinymce.get('editor').dom.select('.letter-content');
                contentsEditorLeft.forEach((element, index) => {
                    contentData += ` ${element.innerHTML}`;
                });
                separatorList.forEach((separator) => {
                    if(!contentData.toLowerCase().includes(separator))
                        selectedSeparator = separator;
                });
                contentsEditorLeft.forEach((element, index) => {
                    content += element.innerHTML;
                    if (index < (contentsEditorLeft.length - 1)) {
                        content += selectedSeparator;
                    }
                });
                $this.isSpining = true;
                var timerInterval;
                Swal.fire({
                    title: `${this.localizationStore.translate("spin.letter.popup.title")}`,
                    // icon: 'info',
                    html: `<span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span> ${this.localizationStore.translate("spin.letter.popup.message")}`,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    willOpen: function (sweetalert) {
                        sweetalert.querySelector('.swal2-html-container')
                            .classList
                            .add('d-flex', 'align-items-center', 'justify-content-center');
                    }
                });
                if (this.defaultSpinner == 'wordai') {
                    // var range = this.$refs.sliderChangsPerSentence.noUiSlider.get();
                    payload = {
                        content: content,
                        // range: range == 0 ? 1 : range
                    };
                    // tinymce.get('editor-right').setContent($this.editorRef.innerHTML);
                    // var elements = tinymce.get('editor-right').dom.select('.letter-content');
                    // this.callSpin(this, elements, range, elements.length-1);
                    // return;
                }
                else if (this.defaultSpinner == 'spinbot') {
                    // var range = parseInt((this.$refs.sliderChangsPerSentence.noUiSlider.get() / 25) * 17.5),
                    payload = {
                        content: content,
                        tags: this.tags.map((tag) => { return tag['text'] }),
                        // range: range == 0 ? 1 : range
                    };
                }
                else {
                    // var range = this.$refs.sliderChangsPerSentence.noUiSlider.get();
                    payload = {
                        content: content,
                        tags: this.tags.map((tag) => { return tag['text'] }),
                        // range: range == 0 ? 1 : range
                    };
                }
                axios.post(letterSpinUrl, payload)
                .then(function (response) {
                    $this.isSpining = false;
                    Swal.close();
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.userStore.user.balance = response.data.data.balance;
                    const updatedContents = response.data.data.content.split(selectedSeparator);
                    tinymce.get('editor').setContent($this.editorRef.innerHTML);
                    tinymce.get('editor').dom.select('.letter-content').forEach((element, index) => {
                        element.classList.add("letter-content-background");
                        element.innerHTML = updatedContents[index];
                    });
                })
                .catch(function (error) {
                    $this.isSpining = false;
                    toastr.error(error.message, 'Error!');
                });
            },
            spin: function (letter) {
                var $this = this, payload = {};
                this.counter(letter);
                if (this.charaterCount > this.spinStore.maxCharaterAllowed) {
                    toastr.error(`Cannot Spin more than ${this.spinStore.maxCharaterAllowed}`, 'Error!');
                    return;
                }
                let separatorList = ['separator', 'null'],
                    selectedSeparator = '||||',
                    contentData = '',
                    content = '',
                    letterContent = letter.dom.select('.letter-content'),
                    route = this.$router.resolve({
                        name: 'spin-letter'
                    });
                letterContent.forEach((element, index) => {
                    contentData += ` ${element.innerHTML}`;
                });
                separatorList.forEach((separator) => {
                    if(!contentData.toLowerCase().includes(separator))
                        selectedSeparator = separator;
                });
                letterContent.forEach((element, index) => {
                    content += element.innerHTML;
                    if (index < (letterContent.length - 1)) {
                        content += selectedSeparator;
                    }
                });
                $this.isSpining = true;
                var timerInterval;
                Swal.fire({
                    title: `${this.localizationStore.translate("spin.letter.popup.title")}`,
                    html: `<span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span> ${this.localizationStore.translate("spin.letter.popup.message")}`,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    willOpen: function (sweetalert) {
                        sweetalert.querySelector('.swal2-html-container')
                            .classList
                            .add('d-flex', 'align-items-center', 'justify-content-center');
                    }
                });
                if (this.defaultSpinner == 'wordai') {
                    payload = {
                        content: content
                    };
                }
                else if (this.defaultSpinner == 'spinbot') {
                    payload = {
                        content: content,
                        tags: this.tags.map((tag) => { return tag['text'] })
                    };
                }
                else {
                    payload = {
                        content: content,
                        tags: this.tags.map((tag) => { return tag['text'] }),
                    };
                }
                axios.post(route.href, payload)
                .then(function (response) {
                    $this.isSpining = false;
                    Swal.close();
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.userStore.user.balance = response.data.data.balance;
                    const updatedContents = response.data.data.content.split(selectedSeparator);
                    letter.dom.select('.letter-content').forEach((element, index) => {
                        element.classList.add("letter-content-background");
                        element.innerHTML = updatedContents[index];
                    });
                })
                .catch(function (error) {
                    $this.isSpining = false;
                    toastr.error(error.message, 'Error!');
                });
            },
            counter: function (letter = null) {
                this.charaterCount = 0
                tinymce.activeEditor.dom.select('.letter-content').forEach((element, index) => {
                    if (_.isNull(letter)) {
                        tinymce.activeEditor.dom.select('.letter-content').forEach((element, index) => {
                            this.charaterCount += element.innerHTML.length;
                        });
                        return;
                    }
                    letter.dom.select('.letter-content').forEach((element, index) => {
                        this.charaterCount += element.innerHTML.length;
                    });
                });
            }
        }
    }
</script>
